// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateCustomerSubscriptionNote_createButton__-WjMw","buttonsContainer":"CreateCustomerSubscriptionNote_buttonsContainer__2LSDB"};